module.exports = __webpack_public_path__ + "media/CN_002.aae13956.mp3";